export default __webpack_public_path__ + "static/media/hero_back_4.2647167e.jpg";